/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OrderBigTablePageReqVo } from './OrderBigTablePageReqVo';
import {
    OrderBigTablePageReqVoFromJSON,
    OrderBigTablePageReqVoFromJSONTyped,
    OrderBigTablePageReqVoToJSON,
    OrderBigTablePageReqVoToJSONTyped,
} from './OrderBigTablePageReqVo';

/**
 * 
 * @export
 * @interface DownloadShippingInfoReqVo
 */
export interface DownloadShippingInfoReqVo {
    /**
     * 海运资料导出基准日期
     * 基准时间
     * @type {string}
     * @memberof DownloadShippingInfoReqVo
     */
    baseTime?: string;
    /**
     * 订单状态，与勾选下载时的列表状态一致
     * 订单状态
     * @type {number}
     * @memberof DownloadShippingInfoReqVo
     */
    orderStatus?: number;
    /**
     * 勾选下载的订单ID
     * 订单id列表
     * @type {Array<number>}
     * @memberof DownloadShippingInfoReqVo
     */
    orderIds?: Array<number>;
    /**
     * 
     * @type {OrderBigTablePageReqVo}
     * @memberof DownloadShippingInfoReqVo
     */
    orderBigTablePageReqVO?: OrderBigTablePageReqVo;
}

/**
 * Check if a given object implements the DownloadShippingInfoReqVo interface.
 */
export function instanceOfDownloadShippingInfoReqVo(value: object): value is DownloadShippingInfoReqVo {
    return true;
}

export function DownloadShippingInfoReqVoFromJSON(json: any): DownloadShippingInfoReqVo {
    return DownloadShippingInfoReqVoFromJSONTyped(json, false);
}

export function DownloadShippingInfoReqVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DownloadShippingInfoReqVo {
    if (json == null) {
        return json;
    }
    return {
        
        'baseTime': json['baseTime'] == null ? undefined : json['baseTime'],
        'orderStatus': json['orderStatus'] == null ? undefined : json['orderStatus'],
        'orderIds': json['orderIds'] == null ? undefined : json['orderIds'],
        'orderBigTablePageReqVO': json['orderBigTablePageReqVO'] == null ? undefined : OrderBigTablePageReqVoFromJSON(json['orderBigTablePageReqVO']),
    };
}

export function DownloadShippingInfoReqVoToJSON(json: any): DownloadShippingInfoReqVo {
    return DownloadShippingInfoReqVoToJSONTyped(json, false);
}

export function DownloadShippingInfoReqVoToJSONTyped(value?: DownloadShippingInfoReqVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'baseTime': value['baseTime'],
        'orderStatus': value['orderStatus'],
        'orderIds': value['orderIds'],
        'orderBigTablePageReqVO': OrderBigTablePageReqVoToJSON(value['orderBigTablePageReqVO']),
    };
}

